import React, { Component, memo, useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import "./styles.css";
import { arrayHelper } from "../../helpers/arrayHelper";

function isEqual(prevProps, nextProps) {
  if (nextProps.preview == true) {
    return false;
  }
  if(nextProps && prevProps && nextProps.changeKey != prevProps.changeKey){
    return false;
  }
  if (nextProps && prevProps && nextProps.list && prevProps.list) {
    if (nextProps.list.length === prevProps.list.length) {
      if (nextProps.compareParam) {
        let hasChanged = arrayHelper.compareChanges(nextProps.list, prevProps.list, nextProps.compareParam);
        return !hasChanged;
      }
    }
  }
  //default to not equal
  return false;
}
const ReactEternalList = memo(({ list, onUpdate, preview, clientListTemplate, component, updateRate }) => {
  const [listItemHeight, setListItemHeight] = useState(80);
  const [forceReRender, setForceReRender] = useState(true);
  const [renderList, setRenderList] = useState({});
  const containerRef = useRef();
  const dummyElRef = useRef();
  const containerTopRef = useRef();
  const updateOnScrollRef = useRef();
  const recursiveSplit = (data) => {
    if (data.length / 2 > 10) {
      let mid = Math.floor(data.length / 2, 10);
      let node = {
        parent: true,
        getParent: () => data,
        data: [recursiveSplit(data.slice(0, mid)), recursiveSplit(data.slice(mid, data.length + 1))],
      };
      return node;
    }
    return {
      parent: false,
      data,
    };
  };
  const updateNodeDimension = (node) => {
    if (node.parent) {
      node.height = 0;
      let temp;
      for (let idx = 0; idx < node.data.length; idx++) {
        temp = updateNodeDimension(node.data[idx]);
        node.height += temp.height;
      }
      node.top = node.data[0] ? node.data[0].top : 0;
      node.bottom = node.top + node.height;
    } else {
      node.height = (node.data || []).length * listItemHeight;
      node.top = containerTopRef.current;
      node.bottom = node.top + node.height;
      containerTopRef.current = containerTopRef.current + node.height;
    }
    return node;
  };
  const updateNodeVisibility = (node) => {
    let isVisible = isNodeVisible(node);
    node.visible = isVisible;
    if (node.visible && node.parent) {
      for (let idx = 0; idx < node.data.length; idx++) {
        updateNodeVisibility(node.data[idx]);
      }
    }
  };
  const isNodeVisible = (node) => {
    if (!containerRef.current) return false;
    return (
      node.top <= containerRef.current.scrollTop + parseInt(containerRef.current.clientHeight, 10) * 1.5 &&
      node.bottom - parseInt(containerRef.current.clientHeight, 10) * -0.5 >= containerRef.current.scrollTop
    );
  };
  useEffect(() => {
    if (preview) {
      updateRenderList();
    }
  }, [clientListTemplate]);
  useEffect(() => {
    updateRenderList();
  }, []);
  useEffect(() => {
    updateRenderList();
  }, [list, listItemHeight]);

  const updateRenderList = () => {
    let newList = recursiveSplit(list);
    containerTopRef.current = 0;
    updateNodeDimension(newList);
    updateNodeVisibility(newList);
    setRenderList(newList);
  };

  useEffect(() => {
    if (dummyElRef.current && dummyElRef.current.clientHeight !== listItemHeight) {
      setListItemHeight(dummyElRef.current.clientHeight);
    }
  }, [dummyElRef.current]);

  const handleScroll = (e) => {
    if (!updateOnScrollRef.current)
      updateOnScrollRef.current = setTimeout(() => {
        updateOnScrollRef.current = null;
        updateNodeVisibility(renderList);
        setForceReRender(!forceReRender);
      }, 100);
  };

  const getChildren = (node) => {
    if (node.parent) {
      return (node.data || []).map((item, index) => {
        return (
          <div className={"ilParent"} key={"par-" + index} style={{ height: item.height }}>
            {item.visible ? getChildren(item) : ""}
          </div>
        );
      });
    } else {
      return (node.data || []).map((item, index) => {
        return component(item, index);
      });
    }
  };
  return (
    <div className={"eternalList dark-list jir-scroll"} onScroll={handleScroll} ref={containerRef}>
      {list && list.length > 0 ? (
        <React.Fragment>
          <div className={"ilDummy"}>
            {list && list.length > 0 ? (
              <div className={"dummyContainer"} ref={dummyElRef}>
                {component(list[0])}
              </div>
            ) : null}
          </div>
          <div className={"ilContainer"}>{getChildren(renderList)}</div>
        </React.Fragment>
      ) : null}
    </div>
  );
}, isEqual);
export default ReactEternalList;
